export const HELP_CONTENT_EXPERIMENT_FF_NAME = 'team-customer-engagement-no-help-content';
export const SHOW_INLINE_ARTICLE_FF_NAME = 'show-articles-inline-in-messenger';

export default {
  HELP_CONTENT_EXPERIMENT_FF_NAME,
  SHOW_INLINE_ARTICLE_FF_NAME,
};
